import React from "react";
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  RocketLaunch,
  Devices,
  Security,
  TrendingUp,
  SupportAgent,
  Sync,
} from "@mui/icons-material";

const Features = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const features = [
    {
      icon: <RocketLaunch fontSize="large" />,
      title: "Cutting-Edge Technology",
      description:
        "We leverage the latest technologies to build robust, scalable, and secure applications that meet the evolving needs of our users.",
    },
    {
      icon: <Devices fontSize="large" />,
      title: "User-Friendly Design",
      description:
        "Our applications feature intuitive interfaces designed with the user in mind, ensuring a seamless experience across all devices.",
    },
    {
      icon: <Security fontSize="large" />,
      title: "Secure & Reliable",
      description:
        "Security is our top priority. We implement industry-standard security measures to protect your data and ensure reliable service.",
    },
    {
      icon: <TrendingUp fontSize="large" />,
      title: "Data-Driven Solutions",
      description:
        "Our applications are built on data analytics to provide insights and features that help users make informed decisions.",
    },
    {
      icon: <SupportAgent fontSize="large" />,
      title: "24/7 Support",
      description:
        "Our dedicated support team is available around the clock to assist with any questions or issues you may encounter.",
    },
    {
      icon: <Sync fontSize="large" />,
      title: "Continuous Innovation",
      description:
        "We're constantly evolving our products with new features and improvements based on user feedback and emerging technologies.",
    },
  ];

  return (
    <Box
      id="features"
      sx={{
        py: 8,
        backgroundColor: "#caf0f8",
      }}
    >
      <Container maxWidth="lg">
        <Box textAlign="center" mb={6}>
          <Typography
            variant={isMobile ? "h4" : "h3"}
            component="h2"
            gutterBottom
            sx={{ color: "#0077b6", fontWeight: "bold" }}
          >
            Why Choose AmpleLark Technologies
          </Typography>
          <Typography
            variant="body1"
            sx={{
              maxWidth: 700,
              mx: "auto",
              color: "#6c757d",
            }}
          >
            We're committed to creating innovative solutions that make everyday
            tasks easier and more efficient.
          </Typography>
        </Box>

        <Grid container spacing={4} justifyContent="center">
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  p: 3,
                  borderRadius: 3,
                  boxShadow: "0 10px 30px rgba(0, 0, 0, 0.05)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-10px)",
                    boxShadow: "0 15px 40px rgba(0, 0, 0, 0.1)",
                  },
                }}
              >
                <Box
                  sx={{
                    width: 70,
                    height: 70,
                    background: "linear-gradient(135deg, #0077b6, #00b4d8)",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 2.5,
                    color: "white",
                  }}
                >
                  {feature.icon}
                </Box>
                <CardContent sx={{ p: 0, width: "100%" }}>
                  <Typography
                    variant="h6"
                    component="h3"
                    gutterBottom
                    sx={{ color: "#0077b6", fontWeight: "bold" }}
                  >
                    {feature.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#6c757d",
                      lineHeight: 1.6,
                    }}
                  >
                    {feature.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Features;
